/* import { ToasterComponent } from './toasterComponent'; */
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'pageAuthorization',
    templateUrl: 'pageAuthorization.component.html',
    styleUrls: ['../../biAdminStyles.css']
})

export class pageAuthorizationComponent {

    @ViewChild('file')
    fileInput: ElementRef;

    public paData: any = { id: null, userId: null, pageSectionId: null, deleted: 0 };
    public pageInfo: any = { id: null, name: null, pageCode: null };
    public empData: any = { id: null, empCode: null };
    public mainPage: boolean = true;
    public paPage: boolean = false;
    public uploadSucess: boolean = false;
    public pageList: any = [];
    public pageSectionList: any = [];
    public pageAuthList: any = [];
    public modifiedPAList: any = [];
    public empList: any = [];
    public empIdList: any = [];
    public paMap: any = new Map();
    public paModifiedMap: any = new Map();
    public paCntMap: any = new Map();
    public uploadedDataList: any = [];
    public removedDataList: any = [];
    //public nonExistentPages: any = [];
    public nonExistentAccess: any = [];
    public nonExistentPageSections: any = [];
    public nonExistentUsers: any = [];
    public saveChangesButton: boolean = false;
    public selectedAll: number[] = [];
    public userRoleData: any;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public file: any = null;
    public selectedPaged: any = 1;
    public formdata: FormData;
    public timeInterval: number;
    public progress: number = 0;
    public token: any;

    public pageNo: number = 1;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public endingPage: number = 10;
    public currentPage: number = 1;
    public totalEmps: number = 0;

    public totalPA: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;
    public employeePageData: any = [];
    public isProgress: boolean = false;
    public count = 0;
    public tabs: any = ['Individual', 'Bulk'];
    public selectedTab = this.tabs[0];

    //public isSearchUsed: boolean;
    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    };

    public authPageNo: number = 0;
    public authPageSize: number = 10;
    public authStartingPage: number = 0;
    public authEndingPage: number = 10;
    public authCurrentPage: number = 1;
    public authTotalRecs: number = 0;

    public tableData: any = [];
    public comment: any = '';
    private fileNameToUpload: any = null;

    constructor(
        public pageAuthorizationService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(this.vcr);
    }

    public ngOnInit() {
        if (this.pageAuthorizationService.isBIAdmin) {
            this.loadData();
        } else {
            this.accessDenied = true;
        }
    }

    public onPageChange(event: number): void {
        console.log('On Page Change Controller ...');
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.isSearchUsed() ? this.getEmployee() : this.loadData();

    }

    // public employeesFound(event) {
    //     this.empList = event;
    // }

    public isSearchUsed() {
        let flag = false;
        if (this.searchData.nameOrCodeOrEmail != "") { flag = true; }
        else if (this.searchData.employeeCodes != []) { flag = true; }
        else if (this.searchData.excludedEmployeeCodes != []) { flag = true; }
        else if (this.searchData.includeEmpIds != []) { flag = true; }
        else if (this.searchData.excludeEmpIds != []) { flag = true; }
        else if (this.searchData.gradeIds != []) { flag = true; }
        else if (this.searchData.mgrLevelIds != []) { flag = true; }
        else if (this.searchData.designationIds != []) { flag = true; }
        else if (this.searchData.categoryIds != []) { flag = true; }
        else if (this.searchData.includeOrgIds != []) { flag = true; }
        else if (this.searchData.excludeOrgIds != []) { flag = true; }
        else if (this.searchData.supervisorIds != []) { flag = true; }
        else if (this.searchData.primarySupervisorIds != []) { flag = true; }
        else if (this.searchData.primarySupervisorCods != []) { flag = true; }
        else if (this.searchData.primarySupervisorNameOrCode != null) { flag = true; }
        else if (this.searchData.employeeStatus != null) { flag = true; }
        else if (this.searchData.employeesWithOutSupervisor != null) { flag = true; }
        else if (this.searchData.scorecardStates != null) { flag = true; }
        else if (this.searchData.memberShipState != null) { flag = true; }
        else if (this.searchData.programId != null) { flag = true; }
        else if (this.searchData.fetchSupervisorLevels != 0) { flag = true; }
        return flag;
    }

    public OnPageSizeChanged(event) {
        console.log('On Page-Size Change Controller ...');
        this.pageSize = event.target.value;
        this.setMaxPage().then((res) => {
            this.isSearchUsed() ? this.getEmployee() : this.loadData();
        })
        //this.loadData();
    }

    public setMaxPage() {
        return new Promise((resolve) => {
            let maxPage = Math.floor(this.totalEmps / this.pageSize);
            if (maxPage < this.pageNo) {
                this.pageNo = maxPage;
            }
            resolve('Completed');
        });
    }

    public loadData() {
        let self = this;
        self.loadPages().then((res) => {
            if (self.selectedPaged != undefined) {
                self.getEmployee().then(() => {
                    self.loadPageSections().then(() => {
                        self.loadPageAuthorizations();
                    });
                });
            } else {
                self.pageSectionList = [];
            }
        }, (err) => {
            console.error(err);
        });
    }

    public bulkUpload(event) {
        // console.log(event);
        let self = this;
        let formdata1 = new FormData();
        if (self.validateFile(self.file)) {
            self.loader = true;
            formdata1.append('file', self.file);
            self.pageAuthorizationService.bulkUpload(BiUrls.PAGE,
                BiUrls.BULKUPLOAD_PAGE_AUTH, formdata1).then((res) => {
                    if (res) {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            if (self.token) {
                                self.isProgress = true;
                                setTimeout(() => {
                                    self.checkProgress();
                                }, self.timeInterval * 1000);
                            }
                        } else {
                            self.toastr.showError(res.errorMessage);
                        }
                        self.loadData();
                    }
                    self.loader = false;
                }, (err) => {
                    console.error(err);
                });
        } else {
            self.toastr.showError('Please Attach An Excel File');
        }
    }

    public validateFile(file) {
        let ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        } else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1].toLowerCase() == 'xls' || ext[1].toLowerCase() == 'xlsx')) {
            return false;
        } else {
            return true;
        }
    }

    public checkProgress() {
        let self = this;
        if (self.count == 10) {
            self.count = 0;
            self.progress = 0;
            self.isProgress = false;
            self.toastr.showError("Bulk Upload Failed");
            return;
        }
        this.pageAuthorizationService.getProgress(self.token, 'trackProgress/bi_bulk_pa_/').then(res => {
            // if(res && res.success){
            if (Math.round(+res.data) == self.progress) {
                self.count += 1;
            }
            self.progress = Math.round(+res.data);
            if (self.progress < 100) {
                setTimeout(() => {
                    self.checkProgress();
                }, self.timeInterval * 1000);
            } else if (self.progress == 100) {
                self.isProgress = false;
                self.pageAuthorizationService.getProgress(self.token, 'statusReport/bi_bulk_pa_/').then(res => {
                    self.progress = 0;
                    self.toastr.showSuccess("Bulk Upload Successful");
                    self.loadUploadReport(res);
                });
            }
            // }
        });
    }

    public loadUploadReport(result) {
        let self = this;
        let statusMap = this.jsonToMap(result);

        this.nonExistentUsers = statusMap.get('NON_EXISTENT_USERS');
        //this.nonExistentPages = statusMap.get('NON_EXISTENT_PAGES');
        this.nonExistentAccess = statusMap.get('NON_EXISTENT_ACCESS');
        this.nonExistentPageSections = statusMap.get('NON_EXISTENT_PAGE_SECTIONS');
        this.uploadedDataList = statusMap.get('UPLOADED_PA_DATA');
        this.removedDataList = statusMap.get('REMOVED_PA_DATA');
    }

    public jsonToMap(res: any) {
        let jsonObj = JSON.parse(JSON.stringify(res.data));
        let map = new Map();
        for (let k of Object.keys(jsonObj)) {
            map.set(k, jsonObj[k]);
        }
        return map;
    }

    public fileChange(event) {
        let size = +event.target.files[0].size / (1024 * 1024);
        if (size < 1) {
            this.timeInterval = 1; // less then 1 MB
        } else if (size < 5) {
            this.timeInterval = 2; // less then 5 MB
        } else if (size < 10) {
            this.timeInterval = 3; // less then 10 MB
        } else if (size > 10) {
            this.timeInterval = 5; // greater then 10 MB
        }
        // console.log(event);
        this.file = event.target.files[0];
    }

    public onSelectPage(event) {
        this.loader = true;
        this.pageList.filter((item) => {
            if (event.target.value == item.id) {
                this.selectedPaged = item.id;
                this.loadPageSections().then(res => {
                    this.mainPage = true;
                    this.loadPageAuthorizations();
                    this.loader = false;
                    console.log('Selected Page : ' + item.id);
                }, (err) => {
                    console.error(err);
                });
            }
        });
    }

    public loadPages() {
        return new Promise((resolve) => {
            let self = this;
            this.pageAuthorizationService.onStartUp('../' + BiUrls.BIADMIN + '/' + BiUrls.ALL_DASHBOARDS)
                .then((res) => {
                    //this.pageAuthorizationService.onStartUp(BiUrls.PAGE).then((res) => {
                    //this.pageAuthorizationService.onStartUp(BiUrls.DASHBOARD_PAGES).then((res) => {
                    if (res != undefined) {
                        self.pageList = res.data != null ? res.data : [];
                        if (self.pageList.length > 0) {
                            self.selectedPaged = self.pageList[0] != undefined ?
                                self.pageList[0].id : null;
                        }
                    }
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    public loadEmployees() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            let url = BiUrls.PAGE + BiUrls.ALL_P_EMPLOYEES;
            self.pageAuthorizationService.getDataByPage(url, self.pageNo, self.pageSize).then(
                (res) => {
                    self.empList = [];
                    self.empIdList = [];
                    if (res == undefined) {
                        self.toastr.showError('Cannot load the Employee Data');
                    } else {
                        self.empList = res.data.pageElements != undefined ?
                            res.data.pageElements.length == 0 ?
                                self.toastr.showWarning('No Employees to load') :
                                res.data.pageElements :
                            self.toastr.showError('No Employees found');
                        self.totalEmps = res.data.total;
                        self.setEndingPage(self.totalEmps);
                        self.setEmpIdList(self.empList);
                    }
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    public setEmpIdList(empList) {
        return new Promise((resolve) => {
            let self = this;
            for (let emp of empList) {
                self.empIdList.push(emp.id);
            }
            resolve('Completed');
        });
    }

    public loadPageSections() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.pageSectionList = [];
            let url = BiUrls.PAGE + BiUrls.GET_SECTIONS_BY_PAGE;
            this.pageAuthorizationService.getDataById(url, self.selectedPaged).then((res) => {
                if (res != undefined) {
                    self.pageSectionList = res.data != null ? res.data : [];
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, (err) => {
                console.error(err);
            });
        });
    }

    public loadPageAuthorizations() {
        let self = this;
        self.loader = true;
        self.selectedAll = [];
        self.paCntMap.clear();
        self.paMap.clear();
        self.paModifiedMap.clear();
        self.modifiedPAList = [];
        self.pageAuthList = [];
        return new Promise<any>((resolve, reject) => {
            self.pageAuthorizationService.loadPageAuthorizations(
                BiUrls.PAGE + BiUrls.GET_PAGE_AUTH_BY_USER_AND_PAGE,
                self.empIdList, self.selectedPaged).then((res) => {
                    if (res != undefined) {
                        self.pageAuthList = res.data != null ? res.data : [];
                    }
                    self.setPA_paCntMap();
                    for (let i = 0; i < self.empIdList.length; i++) {
                        self.setSelectedAll(i, self.empIdList[i]);
                    }
                    self.loader = false;
                    self.mainPage = true;
                    resolve('Completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    public setSelectedAll(index, empId?) {
        let self = this;
        // console.log(self.paCntMap.get(empId));       
        if (self.pageSectionList.length == self.paCntMap.get(empId)) {
            let enable = [];
            let disable = [];
            let lock = [];
            let flag = false;
            for (let j = 0; j < self.pageSectionList.length; j++) {
                if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 0) {
                    enable.push(0);
                } else if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 1) {
                    disable.push(1);
                } else if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 2) {
                    lock.push(2);
                }
            }
            if (self.pageSectionList.length == enable.length) {
                self.selectedAll[index] = 0;
            } else if (self.pageSectionList.length == disable.length) {
                self.selectedAll[index] = 1;
            } else if (self.pageSectionList.length == lock.length) {
                self.selectedAll[index] = 2;
            } else {
                self.selectedAll[index] = 3;
            }
        } else {
            self.selectedAll[index] = 3;
        }
        if (!self.paCntMap.has(empId) || self.paCntMap.get(empId) == 0) {
            self.selectedAll[index] = 1;
        }
    }

    public setPA_paCntMap() {
        let self = this;
        for (let paData of self.pageAuthList) {
            if (!self.paMap.has(paData.userId + '_' + paData.pageSectionId)) {
                self.paMap.set(paData.userId + '_' + paData.pageSectionId, paData.state);
                if (!self.paCntMap.has(paData.userId)) {
                    self.paCntMap.set(paData.userId, 1);
                } else if (self.paCntMap.has(paData.userId)) {
                    let value = self.paCntMap.get(paData.userId);
                    self.paCntMap.set(paData.userId, value + 1);
                }
            }
        }
        // console.log(self.paCntMap);     
    }

    public selectAll(empId, index, currState) {
        let self = this;
        self.selectedAll[index] = currState;
        self.saveChangesButton = true;
        let paData: any;
        for (let ps of self.pageSectionList) {
            self.paMap.set(empId + '_' + ps.id, currState);
            paData = {
                id: null, userId: empId, state: currState,
                pageSectionId: ps.id, deleted: currState == 1 ? true : false
            };
            self.paModifiedMap.set(empId + '_' + ps.id, paData);
        }
    }

    // public onChange1(event, index) {
    //     let self = this;
    //     let empId = event.target.id;
    //     let psId = event.target.value;
    //     let chbox = event.target.checked;
    //     self.saveChangesButton = true;
    //     console.log('( ' + empId + ' , ' + psId + ' ) = ' + chbox);
    //     self.paMap.set(empId + '_' + psId, chbox);
    //     let paData = {
    //         id: null, userId: empId,
    //         pageSectionId: psId, deleted: !chbox
    //     };
    //     let value = self.paCntMap.get(paData.userId);
    //     if (chbox) {
    //         self.paCntMap.set(paData.userId, value + 1);
    //     } else {
    //         self.paCntMap.set(paData.userId, value - 1);
    //     }
    //     self.setSelectedAll(index);
    //     self.paModifiedMap.set(empId + '_' + psId, paData);
    // }

    public onCloseSummary(event) {
        this.uploadSucess = false;
    }

    public onSaveChanges(event) {
        let self = this;
        self.modifiedPAList = Array.from(self.paModifiedMap.values());
        self.setPaIdForModifiedEntries();
        self.cleanModifiedPAList();
        let url = BiUrls.PAGE + BiUrls.SAVE_MULTIPLE_PAGE_AUTH;
        self.loader = true;
        self.pageAuthorizationService.onSaveOrUpdate(url, self.modifiedPAList).then(
            function (success: any) {
                if ((success.errorMessage != null || success.errorMessage != undefined)) {
                    console.log(success.errorMessage);
                    self.mainPage = false;
                    self.accessDenied = true;
                    self.saveChangesButton = false;
                    return;
                } else {
                    self.toastr.showSuccess('Changes saved successsfully');
                }
                // self.loadData();
                //self.loadPageAuthorizations();
                self.saveChangesButton = false;
                self.loader = false;
            },
            function (error) {
                self.toastr.showError('Failed to save changes');
                console.log(error);
            }
        );
    }

    public setPaIdForModifiedEntries() {
        let self = this;
        for (let paData of self.modifiedPAList) {
            for (let item of self.pageAuthList) {
                if (item.userId == paData.userId && item.pageSectionId == paData.pageSectionId) {
                    paData.id = item.id;
                }
            }
        }
    }

    public cleanModifiedPAList() {
        let self = this;
        for (let paData of self.modifiedPAList) {
            if (paData.id == null) {
                if (paData.deleted == false) {
                    paData.deleted = null;
                } else {
                    let index = self.modifiedPAList.indexOf(paData);
                    self.modifiedPAList.splice(index, 1);
                }
            }
        }
    }

    // public loaderControl(event) {
    //     this.loader = event;
    // }

    // public pageDataControl(event) {
    //     this.employeePageData = event;
    //     this.totalEmps = event.totalElements;
    //     this.setEndingPage(this.totalEmps);
    // }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            self.startingPage = 0;
            if (total > self.pageSize) {
                self.endingPage = self.pageSize;
            } else {
                self.endingPage = total;
            }
        } else {
            self.startingPage = 0 + ((self.currentPage - 1) * + self.pageSize);
            self.endingPage = +self.pageSize + ((self.currentPage - 1) * +self.pageSize);
            if (self.endingPage > total) {
                self.endingPage = total;
            }
        }
    }

    showSearchFilter(event) {
        this.searchData = event;
        this.getEmployee();
    }

    getEmployee() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.searchData.page = self.currentPage;
            self.searchData.pageSize = self.pageSize;
            self.pageAuthorizationService.getEmployee(self.searchData).then((result) => {

                self.empList = [];
                self.empIdList = [];
                self.empList = result.content;
                self.employeePageData = result;
                //self.loadData();
                self.totalEmps = result.totalElements;
                if (self.empList != undefined && self.empList.length != 0) {

                    self.setEmpIdList(self.empList).then((res) => {
                        if (res != undefined) {
                            self.loadPageAuthorizations();
                        }
                    });
                    resolve('')
                    self.setEndingPage(self.totalEmps);
                }
                self.loader = false;
            }, (err) => {
                self.toastr.showError('Failed to get employee details..');
                console.error(err);
            });
        });

    }

    public onChange(empId, psId, index, chbox) {
        let self = this;
        self.saveChangesButton = true;
        console.log('( ' + empId + ' , ' + psId + ' ) = ' + chbox);
        let paData = {
            id: null, userId: empId,
            pageSectionId: psId, deleted: chbox == 1 ? true : false,
            state: chbox
        };
        let prevState = self.paMap.has(empId + '_' + psId) ? self.paMap.get(empId + '_' + psId) : chbox;
        self.paMap.set(empId + '_' + psId, chbox);
        let value = self.paCntMap.has(paData.userId) ? self.paCntMap.get(paData.userId) : 0;
        if (prevState == 1 && chbox != 1) {
            self.paCntMap.set(paData.userId, value + 1);
        } else if (prevState != 1 && chbox == 1) {
            self.paCntMap.set(paData.userId, value - 1);
        } else if (prevState == chbox && chbox != 1) {
            self.paCntMap.set(paData.userId, value + 1);
        }
        self.setSelectedAll(index, empId);
        self.paModifiedMap.set(empId + '_' + psId, paData);
    }

    beforeChange(event) {
        if (event.nextId == 'individual') {
            this.selectedTab = event.nextId;
        } else if (event.nextId == 'bulk') {
            this.selectedTab = event.nextId;
            this.getPageAuthHistory();
        }
    }

    private chooseFile(event) {
        if (event.target.files && event.target.files.length > 0) {
            let self = this;
            this.file = event.target.files[0];
            self.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    }

    public validateBulkOpInput() {
        let self = this;
        let ext = self.file.name.split('.', 2);
        let isValid = true;

        if (ext[1].toLowerCase() != 'xlsx') {
            this.toastr.showError("Please Attach An Excel File");
            isValid =  false;
        }

        if (self.comment.trim() === '') {
            this.toastr.showError("Comment is mandatory");
            isValid =  false;
        }
        return isValid;
    }

    public initBulkPageAuth(event) {
        let self = this;
        let formdata = new FormData();
        if (self.validateBulkOpInput()) {
            self.loader = true;
            formdata.append('file', self.file);
            formdata.append('comment', self.comment);
            self.pageAuthorizationService.bulkUpload('auth/', 'processBulkPageAuth', formdata).then((res) => {
                if (res) {
                    if(res.status == 409) {
                        self.toastr.showError(JSON.parse(res.error).message);
                    } else {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            self.isProgress = true;
                        } else {
                            self.toastr.showError(res.errorMessage);
                        }
                    }

                    self.getPageAuthHistory();
                }
                self.loader = false;
                self.resetBulkOperationParams();
            }, (err) => {
                console.error(err);
                self.resetBulkOperationParams();
                self.loader = false;
            });
        }
    }

    private resetBulkOperationParams() {
        this.comment = '';
        this.fileNameToUpload = null;
    }

    private downloadFiles(url) {
        try {
            this.pageAuthorizationService.mdmService.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
                let name = this.getFileNameFromHeader(result.headers);
                FileSaver.saveAs(result.body, name);
            });
        } catch (e) {
            console.log('download error caught', e);
        }
    }

    private downloadTemplate() {
        let url = this.pageAuthorizationService.base_url + 'biAdmin/auth/downloadTemplate/PAGE_AUTH_TEMPLATE';
        this.downloadFiles(url);
    }

    private downloadPageAuthFiles(filePath) {
        let url = this.pageAuthorizationService.base_url + 'biAdmin/auth/downloadFile/' + filePath;
        this.downloadFiles(url);
    }

    private getFileNameFromHeader(headers: HttpHeaders): string {
        let header = headers.get('Content-Disposition');
        if (header == null) {
            return 'Page_Authorization_Template.xlxs';
        } else {
            if (!header) {
                return null;
            }
            let result: string = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    }

    private getPageAuthHistory() {
        let self = this;
        try {
            let url = self.pageAuthorizationService.base_url +
                'biAdmin/auth/getAllUploadStatus/?processType=BI_PAGE_AUTH_UPLOAD&' +
                'page=' + self.authCurrentPage + '&pageSize=' + self.authPageSize;
            self.pageAuthorizationService.mdmService.get(url).subscribe((response) => {
                this.handlePageAuthHistoryResponse(response);
            });
        } catch (e) {
            console.log('Error: getPageAuthHistory', e);
        }
    }

    private handlePageAuthHistoryResponse(response) {
        if (response && response.content) {
            this.authTotalRecs = response.totalElements;
            this.tableData = response.content;
            this.setPaginationParams();
        }

    }

    public setPaginationParams() {
        let self = this;
        if (self.authCurrentPage == 1) {
            self.authStartingPage = 0;
            if (self.authTotalRecs > self.authPageSize) {
                self.authEndingPage = self.authPageSize;
            } else {
                self.authEndingPage = self.authTotalRecs;
            }
        } else {
            self.authStartingPage = 0 + ((self.authCurrentPage - 1) * + self.authPageSize);
            self.authEndingPage = + self.authPageSize + ((self.authCurrentPage - 1) * + self.authPageSize);
            if (self.authEndingPage > self.authTotalRecs) {
                self.authEndingPage = self.authTotalRecs;
            }
        }
    }

    private onAuthHistoryPageSizeChanged(event) {
        this.authPageSize = event.target.value;
        this.getPageAuthHistory();
    }

    public onAuthHistoryPageChange(event: number): void {
        if (typeof event == 'number' && !isNaN(event)) {
            this.authCurrentPage = event;
            this.getPageAuthHistory();
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/pageAuthorization.component.ts